import { render } from "./HomeCarousel.vue?vue&type=template&id=f5919a92&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"

import "./HomeCarousel.vue?vue&type=style&index=0&id=f5919a92&scoped=true&lang=scss"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5919a92"]])

export default __exports__